import styled from "@emotion/styled";
import { Box } from "../../../primitives/Box/Box";

export const DetailsContainer = styled(Box)`
  height: 83px;
`;

export const SpinnerContainer = styled(Box)`
  height: 16px;
`;
